import { useRef } from 'react';
import { canonicalJson } from '../engine/canonicalJson';

/**
 * A VALUE THAT KEEPS ITS IDENTITY WHILE IT READS THE SAME (plan shell-contexts, A4): the last value returned, as
 * long as `keyOf` says the same of the new one (its canonical JSON by default: key order does not count - Firestore
 * moves a field it just wrote to the end); otherwise the new one. For a small derived
 * value rebuilt on every render - a map of who acts as whom, the people on the vox - that a context holds.
 *
 * `keyOf` must cover everything a reader shows; JSON covers all of it. Not for anything large or hot: the key is
 * worked out on every render.
 *
 * @template T
 * @param {T} value
 * @param {(value: T) => string} [keyOf]
 * @returns {T}
 */
export default function useStableValue(value, keyOf = canonicalJson) {
  const kept = useRef(null);
  const key = keyOf(value);
  if (!kept.current || kept.current.key !== key) kept.current = { key, value };
  return kept.current.value;
}
